import { User as IUser } from "@/api/models/user";
import { uniqBy } from "lodash";

export interface IUserFilter {
  email?: string;
  fullName?: string;
  registeredAtMin?: Date;
  registeredAtMax?: Date;
}

const usersFilter = (users: Array<IUser>, params?: IUserFilter) => {
  return filteredByParams(users, params);
};

const filteredByParams = (users: Array<IUser>, params?: IUserFilter) => {
  const checkByTextField = (searchString: string = "", userField: string) => {
    return searchString
      ? users?.filter(u =>
          //@ts-ignore
          u[userField]?.toLowerCase().includes(searchString.toLowerCase())
        )
      : users;
  };

  let _allSearchedUsers: Array<IUser> = [];

  const regMinParams = params?.registeredAtMin
    ? new Date(params.registeredAtMin).getTime()
    : undefined;

  const regMaxParams = params?.registeredAtMax
    ? new Date(params.registeredAtMax).getTime()
    : undefined;

  _allSearchedUsers = uniqBy(
    [
      ..._allSearchedUsers,
      ...checkByTextField(params?.email, "email"),
      ...checkByTextField(params?.fullName, "fullName")
    ],
    "id"
  );
  _allSearchedUsers = _allSearchedUsers.filter(u => {
    return checkMinRegistrationDate(u.registeredAt, regMinParams);
  });
  _allSearchedUsers = _allSearchedUsers.filter(u => {
    return regMaxParams
      ? checkMaxRegistrationDate(u.registeredAt, regMaxParams)
      : u;
  });

  return _allSearchedUsers;
};

const checkMinRegistrationDate = (regDate: Date, regMin: number = 0) => {
  const registerTime = new Date(regDate).getTime();
  return regMin <= registerTime;
};

const checkMaxRegistrationDate = (regDate: Date, regMax: number = 0) => {
  const getTime = new Date(regDate).getTime();
  return regMax >= getTime;
};

export { usersFilter };
